module.exports = __webpack_public_path__ + "img/check-circle-orange.f2f03d6c.svg";